// @mui
import Stack from "@mui/material/Stack";
import { alpha, useTheme } from "@mui/material/styles";
// hooks
import { useResponsive } from "src/hooks/use-responsive";
// theme
import Logo from "src/components/logo";
import { bgGradient } from "src/theme/css";

// ----------------------------------------------------------------------

type Props = {
  title?: string;
  image?: string;
  children: React.ReactNode;
};

export default function AuthClassicLayout({ children, image, title }: Props) {
  const theme = useTheme();

  const upMd = useResponsive("up", "md");

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: "auto",
        maxWidth: 480,
        px: { xs: 2, md: 8 },
        py: { xs: 15, md: 30 },
        my: "auto",
      }}
    >
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={1}
      spacing={10}
      alignItems="center"
      justifyContent="center"
      sx={{
        ...bgGradient({
          color: alpha(
            theme.palette.background.default,
            theme.palette.mode === "light" ? 0.88 : 0.94,
          ),
          imgUrl: "/assets/background/overlay_2.jpg",
        }),
      }}
    >
      <Logo width="75%" maxWidth={720} />
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: "100vh",
      }}
    >
      {upMd && renderSection}

      {renderContent}
    </Stack>
  );
}
